import {
  CreateWalletTypeRequest,
  UpdateWalletTypeRequest,
  WalletType,
} from "../types/walletType";
import {
  CallResult,
  doApiDelete,
  doApiGet,
  doApiPost,
  doApiPut,
} from "./Requests";

export const walletTypesApi = {
  getWalletTypes: async (): Promise<CallResult<WalletType[]>> => {
    return await doApiGet<WalletType[]>("/api/companies/wallet-types");
  },

  createWalletType: async (
    walletType: CreateWalletTypeRequest
  ): Promise<CallResult<WalletType>> => {
    return await doApiPost("/api/companies/wallet-types", walletType);
  },

  updateWalletType: async (
    id: string,
    walletType: UpdateWalletTypeRequest
  ): Promise<CallResult<WalletType>> => {
    return await doApiPut(`/api/companies/wallet-types/${id}`, walletType);
  },

  deleteWalletType: async (id: string): Promise<CallResult<null>> => {
    return await doApiDelete(`/api/companies/wallet-types/${id}`);
  },
};
